import { render } from "./BulkOrderContainer.vue?vue&type=template&id=2332f8ee"
import script from "./BulkOrderContainer.vue?vue&type=script&lang=js"
export * from "./BulkOrderContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__